import React from "react"
import PropTypes from "prop-types"
import { noop } from "utils"
import { GlobalNavLinkAccordion } from "components"
import { Radium } from "../../higher-order-components"
import componentParser from "AtomicUtils/componentParser"

/**
 * Sub-Navigation Component.
 * @param {Array|FlexContent} components - Nested Components
 * @returns {ReactElement} React Component
 */
const SubNavCompact = ({
  navItems,
  activeItemIndex,
  toggleActive,
  close,
  children,
  hideNavItems
}) => (
  <div style={styles.base} onKeyDown={close} data-test="sub-nav-compact">
    {children}
    <div style={[styles.panel, hideNavItems && { opacity: 0 }]}>
      {navItems.map((comp, index) => {
        if (!comp) return
        if (comp.props.components && comp.props.components.length) {
          return (
            <GlobalNavLinkAccordion
              {...comp.props}
              key={index}
              active={activeItemIndex === index}
              toggleActive={() => toggleActive(index)}
              subNav />
          )
        }
        return (
          <div style={styles.navLinkWrapper} key={index}>
            {componentParser([comp], {
              active: activeItemIndex === index,
              toggleActive: () => toggleActive(index),
              subNav: true
            })}
          </div>
        )
      })}
    </div>
  </div>
)

export default Radium(SubNavCompact)

SubNavCompact.propTypes = {
  children: PropTypes.node,
  navItems: PropTypes.node,
  activeItemIndex: PropTypes.number,
  toggleActive: PropTypes.func,
  close: PropTypes.func,
  hideNavItems: PropTypes.bool
}

SubNavCompact.defaultProps = {
  activeItemIndex: 0,
  toggleActive: noop,
  close: noop
}

const styles = {
  base: {
    position: "absolute",
    top: 0,
    left: "100vw",
    width: "calc(100vw - (3em + 40px))",
    height: "100vh",
    overflow: "scroll",
    background: "#dedede",
    boxSizing: "border-box",
    WebkitOverflowScrolling: "touch",
    transition: "opacity .5s"
  },
  navLinkWrapper: {
    display: "block",
    margin: "auto",
    flex: "1 1 100%"
  },
  panel: {
    transition: "opacity .25s",
    padding: "1em 0"
  }
}



// WEBPACK FOOTER //
// ./src/containers/global-nav/sub-nav-compact.jsx